import { createHtmlElement, isImgLink } from '../../../functions';
import Masonry from 'masonry-layout';
import {
  changeLangToCurrent,
  getCurrentLang
} from '../../components/langSwitcher/langSwitcher';
import {isDesktop, isMobile, settingsData } from '../../../settings';
import {Disclaimer} from "../../components/Disclaimer/Disclaimer";
import { desktopErrorIcon } from '../../widgets/widgets';
import { Cloudflare } from '../../api/Cloudflare';
import PhotoSwipe from '../../../libs/photoswiper/photoswipe.esm';
import '../../../libs/photoswiper/photoswipe.css';
import { BaseElement } from '../../interfaces/BaseElement';
import { DreamsPreloader } from '../../components/preloader/DreamsPreloader';


let masonry;

export function galleryDesktop (parent) {
  const response = config.widgets.gallery;

  const mainContainer = new BaseElement()
      .addClass('desktop__gallery', 'background-backdrop-filter')
      .addAttribute('data-menu-item', 'gallery')
      .appendTo(parent);

  const galleryContainer = new BaseElement()
      .addClass('gallery__main-container')
      .appendTo(mainContainer.DOMElement);

  const disclaimer = new Disclaimer(galleryContainer.DOMElement, 'generalGalleryDisclaimer');
  disclaimer.addClass('gallery-Disclaimer');

  if (!checkCRM(response)){
    showErrorPage(galleryContainer.DOMElement);
    return;
  }

  const styleArray = [
    'grid-item--height2',
    'grid-item--height3',
    'grid-item--height4',
    'grid-item--height5'
  ];

  const menuContent = new BaseElement()
      .addClass('menu-content__wrapper', 'gallery__menu-content__wrapper', 'widget-menu__content-wrapper')
      .appendTo(galleryContainer.DOMElement);

  const tabs = new BaseElement()
      .addClass('gallery__tabs', 'widget-menu__items')
      .appendTo(menuContent.DOMElement);

  const container = new BaseElement()
      .addClass('gallery', 'grid')
      .addAttribute('id','lightGallery')
      .event('click', (e) => {
        e.preventDefault();
        openGallery(e);
      })
      .appendTo(galleryContainer.DOMElement);

  const containerWidth = container.DOMElement.getBoundingClientRect().width;
  const { columnCount, gutter } = settingsData.desktopGallery;
  const gridColumnWidth = isMobile && settingsData.isLandscape
      ? 112
      : Math.floor(containerWidth / columnCount) - gutter;

  new BaseElement('button')
      .addClass(
          'gallery__tab__btn',
          'language-string',
          'text',
          'body',
          'widget-menu__item',
      )
      .setAttributes({
        'data-dictionary': 'All',
        'data-category': 'All',
        'data-active': true
      })
      .text(changeLangToCurrent('All'))
      .appendTo(tabs.DOMElement);

  // new BaseElement('span')
  //     .addClass('widget-menu__separator')
  //     .appendTo(tabs.DOMElement);

  if (response.data.length <= 1)
    menuContent.addClass('hidden');

  response.data.forEach((category) => {
      const order = category?.order || 1;
      new BaseElement('span')
        .addClass('widget-menu__separator')
        .addStyle('order', order)
        .appendTo(tabs.DOMElement);

    const tab = new BaseElement('button')
        .addClass(
            'gallery__tab__btn',
            'language-string',
            'text', 'body',
            'widget-menu__item'
        )
        .addStyle('order', order)
        .appendTo(tabs.DOMElement);

    let categoryName;
    category.name.forEach(name => {
      if (name.lang === getCurrentLang()) {
        if (name.value === '') {
          const englishItem = category.name.find(item => item.lang === 'en');
          const englishTranslation = englishItem && englishItem.value;
          tab.text(englishTranslation);
        } else {
          tab.text(name.value);
        }
      }
      if (name.lang === 'en')
        categoryName = name.value;
      tab.addAttribute(`data-lang-${name.lang}`,name.value);
    });

    tab.setAttributes({
      'data-category': categoryName,
      'data-active': true
    })

    let count = 0;
    category.pictures.forEach((picture, index) =>{
      const item = new BaseElement('a')
          .addClass('grid-item')
          .setAttributes({
            'data-caption': picture.title.filter(text => text.lang === getCurrentLang())[0].value,
            'data-caption-object': JSON.stringify(picture.title),
            'fancybox': 'gallery',
            'data-index-count': count
          })
          .addStyle('width', gridColumnWidth + 'px')
          .appendTo(container.DOMElement);

      let content;
      const isPicture = picture.imageUrl.match(/(.jpg)|(.png)|(.jpeg)/gi);
      if (isPicture) {
        item.addAttribute('href', Cloudflare.resize(picture.imageUrl,{
          width: isMobile ? 1024 : 2880,
          quality: 90
        }));

        content = new BaseElement('img')
            .addClass('gallery__image')
            .addAttribute('src', Cloudflare.resize(picture.imageUrl,{
              width: isDesktop ? 1024 : isMobile ? 200 : 800,
              quality: 75
            }))
            .appendTo(item.DOMElement);
      } else {
        content = new BaseElement('video')
            .addClass('gallery__video')
            .addAttribute('src', picture.imageUrl + '#t=0.5')
            .appendTo(item.DOMElement);
        item
            .addClass('icon-play')
            .addAttribute('href', picture.imageUrl);
      }

      item.addAttribute('data-category-name', categoryName);

      if (index % 2 && !config.features.gallery?.nonMozaic) {
        const randomClass = styleArray[getRandom(0, styleArray.length - 1)];
        item.addClass(randomClass);
      }

      content.setAttributes({
        'data-category-name': categoryName,
        'data-index-count': count
      });

      count++;
    });
  });

  masonry = new Masonry( container.DOMElement, {
    itemSelector: '.grid-item',
    stagger: 30,
    fitWidth: true,
    columnWidth: gridColumnWidth,
    gutter: gutter,
  });
  masonry.userData = {};
  masonry.userData.hidedElements = [];
  window.masonry = masonry;

  tabs.event('click', tabsHandler);
  removeHeightPropertyFromImageContainer();
}

function openGallery ({target}) {
  let targetElement;

  if (target.classList.contains('grid')){
    return;
  } else if (target.classList.contains('gallery__video') || (target.classList.contains('gallery__image'))){
    targetElement = target.parentElement;
  } else if (target.classList.contains('grid-item')){
    targetElement = target;
  }

  const allPictures = masonry.getItemElements();
  const visiblePictures = allPictures.filter(picture => picture.style.display !=='none');

  const selectedIndex = visiblePictures.findIndex(item => item === targetElement);
  const gallery = new PhotoSwiperGallery(visiblePictures,selectedIndex);
  gallery.open();
}

export function resizeGallery () {
  const gallery = document.querySelector('.gallery');
  if (!gallery || gallery.classList.contains('hidden')) return;

  const container = document.querySelector('.gallery .grid');
  if (!container || !masonry) return;

  masonry.destroy();

  const containerWidth = container.getBoundingClientRect().width;
  const { columnCount, gutter } = settingsData.desktopGallery;
  const gridColumnWidth = isMobile && settingsData.isLandscape ? 112 : Math.floor(containerWidth / columnCount) - gutter;
  [...container.children].forEach(el => el.style.width = gridColumnWidth + 'px');

  masonry = new Masonry(container, {
    itemSelector: '.grid-item',
    stagger: 30,
    fitWidth: true,
    columnWidth: gridColumnWidth,
    gutter: gutter,
  });
  masonry.userData = {};
  masonry.userData.hidedElements = [];
  window.masonry = masonry;
  updateLayout();
}

function updateLayout () {
  masonry.layout();
  removeHeightPropertyFromImageContainer();
}

const removeHeightPropertyFromImageContainer = () => {
  const imagesContainer = document.querySelector('.gallery .grid');
  if (imagesContainer)
    imagesContainer.style.removeProperty('height');
}

function tabsHandler ({target}) {
  if (target.dataset.category) {
    if (!validateTabs(target))
      return;

    if (target.dataset.category === 'All') {
      setAllTabsActive();
    } else {
      setActiveCategory(target.dataset.category);
    }

    if (isElementsHidden())
      showHiddenElements(getHiddenElements());

    const items = masonry.getItemElements();
    const categoriesNames = getActiveCategoriesNames();
    const sorted = items.filter(item => !categoriesNames.includes(item.dataset.categoryName));

    hideElements(sorted);
    updateLayout();
  }
}

function setAllTabsActive() {
  const allCategories = [...document.querySelectorAll('.gallery__tab__btn')];
  for (let category of allCategories) {
    category.dataset.active = 'true';
  }
}

function validateTabs (target) {
  const activeTabs = document.querySelectorAll(`.gallery__tab__btn[data-active="true"]`);
  if (activeTabs.length >=2){
    return true;
  } else if (activeTabs[0] === target){
    return false;
  } else if (activeTabs[0] !== target){
    return true;
  }
}

function setActiveCategory (category) {
  const allCategories = [...document.querySelectorAll('.gallery__tab__btn')];
  for (let category of allCategories) {
    category.dataset.active = 'false';
  }
  // if (selectedCategory.dataset.active === 'true'){
  //   selectedCategory.dataset.active = 'false';
  // } else {
  //   selectedCategory.dataset.active = 'true';
  // }
  const selectedCategory = document.querySelector(`.gallery__tab__btn[data-category="${category}"]`);
  if (selectedCategory.dataset.active !== 'true')
    selectedCategory.dataset.active = 'true';
}

function getActiveCategoriesNames () {
  const categoriesNames = [];
  const categories = document.querySelectorAll(`.gallery__tab__btn[data-active="true"]`);

  categories.forEach(category =>{
    categoriesNames.push(category.dataset.category);
  });

  return categoriesNames;
}

function resetHidden () {
  masonry.userData.hidedElements = [];
}

function hideElements (elements) {
  resetHidden();
  masonry.userData.hidedElements = elements;
  // masonry.hideItemElements(elements);
  elements.forEach(el => el.style.display = 'none');
}

function getHiddenElements () {
  return masonry.userData.hidedElements;
}

function isElementsHidden () {
  return Boolean(masonry.userData.hidedElements.length);
}

function showHiddenElements (elements) {
  masonry.revealItemElements(elements || masonry.userData.hidedElements);
  masonry.userData.hidedElements = [];
}

function getRandom(min, max) {
    return Math.round(Math.random() * (max - min) + min);
}

function checkCRM (crm) {
  return  Array.isArray(crm.data) && crm.data.length > 0;
}

function showErrorPage (mainContainer = document.querySelector('.gallery__main-container')) {
  const wrapper = createHtmlElement(mainContainer,'','div',['error-page__wrapper']);
  const icon = createHtmlElement(wrapper,'','div',['error-page__icon']);
  icon.innerHTML = desktopErrorIcon;
  createHtmlElement(wrapper,'The page is under construction','h1',['error-page__title']);
}


export class PhotoSwiperGallery {
  constructor (data = [],index = 0,parent) {
    this.data = data;
    this.parent = parent;
    this.index = index;
    this.parsedData = [];
    this.onClose = () => {};
  }
  
  open() {
    this.#prepareData();
    let preloader = null;
    let timeOut = null;
    
    const options = {
      arrowNextSVG: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34' +
          ' 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"></path></svg>',
      arrowPrevSVG: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"></path></svg>',
      dataSource: this.parsedData,
      appendToEl: this.parent,
      closeOnVerticalDrag: false,
      allowPanToNext: false,
      bgOpacity: 1,
      index: this.index
    };
  
    this.gallery = new PhotoSwipe(options);
  
    this.gallery.on('uiRegister',() => {
      //Disclaimer
      this.gallery.ui.registerElement({
        name: 'disclaimer',
        order: 9,
        isButton: false,
        appendTo: 'root',
        html: '',
        onInit: (el, pswp) => {
          const disclaimer = new Disclaimer(el, 'generalGalleryDisclaimer');
          disclaimer.addClass('gallery-widget__disclaimer');
        }
      });
    
      // Caption register
      this.gallery.ui.registerElement({
        name: 'caption',
        order: 9,
        isButton: false,
        appendTo: 'root',
        html: 'Caption text',
        onInit: (el, pswp) => {
          pswp.on('change', () => {
            if (pswp.currSlide.content.data.alt) {
              el.classList.remove('hidden');
            } else {
              el.classList.add('hidden');
            }
            el.innerHTML =  pswp.currSlide.content.data.alt;
          });
        }
      });
      
      //Preloader
      this.gallery.ui.registerElement({
        name: 'dreams-preloader',
        appendTo: 'root',
        order: 11,
        html: '',
        onInit: (el, pswp) => {
          preloader = new DreamsPreloader(el).absolute();
        }
      })
    });
  
    this.gallery.on('contentActivate',({content}) => {
      
      switch (content.type) {
        case 'video':
          const video = content.element.querySelector('video');
          if (video.readyState === 0) {
            preloader.show();
            const interval = setInterval(() => {
              if (video.readyState === 4) {
                clearInterval(interval);
                preloader.hide();
                video.play();
              }
            },200)
          } else {
            preloader.hide();
            video.play();
          }
          break;
        case 'image':
          content.element.addEventListener('load',() => {
            if (timeOut) {
              clearTimeout(timeOut);
            }
            preloader.hide();
          });
  
          if (timeOut) {
            clearTimeout(timeOut);
            preloader.hide();
          }
          
          timeOut = setTimeout(() => {
            if (content.state !== 'loaded') {
              preloader.show();
            }
          },400);
          break;
      }
    });
  
    this.gallery.on('contentDeactivate',({content}) => {
      if (content.type === 'video') {
        const video = content.element.querySelector('video');
        video.pause();
      }
    });
    
    this.gallery.on('close',this.onClose);
    this.gallery.init();
  }
  
  #prepareData() {
    this.data.forEach(el => {
      if (el instanceof HTMLElement) {
        const captionObject = JSON.parse(el.dataset.captionObject);
        const captionText = captionObject.filter(caption => caption.lang === getCurrentLang())[0].value;
        const element = this.#prepareElement(el.href);
        element.alt = captionText;
        this.parsedData.push(element);
      } else {
        const element = this.#prepareElement(el);
        this.parsedData.push(element);
      }
    });
  }
  
  
  #prepareElement(url) {
    const data = {};
  
    if (isImgLink(url)) {
      data.src = url;
      data.type = 'image';
    } else {
      const content = new BaseElement().DOMElement;
      new BaseElement('video')
          .addClass('pswp__video')
          .addAttribute('controls',true)
          .addAttribute('src',url)
          .appendTo(content);
    
      data.html = content.innerHTML;
      data.type = 'video';
    }
    
    return data;
  }
}
